var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardEach1HourIcon = function SvgNewcsDashboardEach1HourIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_each1hour_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27 331h14v12H27z",
    "data-name": "\\u77E9\\u5F62 329"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_each1hour_icon_svg__a)",
    transform: "translate(-27 -331)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "M35.001 331a6 6 0 0 0-6 6h-2l2.593 2.593.047.094L32.334 337h-2a4.691 4.691 0 1 1 1.374 3.293l-.947.947a6 6 0 1 0 4.24-10.24m-.667 3.333v3.334l2.834 1.68.513-.854-2.347-1.393v-2.767Z",
    "data-name": 0
  }))));
};
export default SvgNewcsDashboardEach1HourIcon;